<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-list-group
            v-if="item.permission == 'vehicles'"
            :key="index"
            v-model="vehiclesExpanded"
            prepend-icon="mdi-car-multiple"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Vehículos</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item link @click="navigate('/vehicles/zero-mileage')">
              <v-list-item-icon>
                <v-icon>mdi-car</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>0 km</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="navigate('/vehicles/posventa')">
              <v-list-item-icon>
                <v-icon>mdi-car</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Posventa</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            link
            :key="item.title"
            @click="navigate(item.route)"
            v-if="
              checkPermission(item.permission) && item.permission != 'vehicles'
            "
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <!-- Admin Dropdown -->

        <v-list-group
          v-if="checkPermission('admin')"
          v-model="adminExpanded"
          prepend-icon="mdi-shield-key"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link @click="navigate('/admin/users')">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="navigate('/admin/roles')">
            <v-list-item-icon>
              <v-icon>mdi-account-key</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Roles</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="navigate('/admin/permissions')">
            <v-list-item-icon>
              <v-icon>mdi-lock-open-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Permisos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="pointer" @click="goTo('/')"
        >Posventa</v-toolbar-title
      >
      <!-- Espaciador para empujar el contenido a la derecha -->
      <v-spacer></v-spacer>

      <!-- Menú desplegable de usuario -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ user.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon color="red">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Salir</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-footer app>
      <span>&copy; 2025 - Posventa</span>
    </v-footer>
  </v-app>
</template>
  
  <script>
export default {
  data: () => ({
    drawer: false,
    adminExpanded: false,
    vehiclesExpanded: false,
    items: [
      { title: "Inicio", icon: "mdi-home", route: "/" },
      {
        title: "Ventas",
        icon: "mdi-currency-usd",
        route: "/sales",
        permission: "sales",
      },
      {
        title: "Servicios",
        icon: "mdi-train-car-flatbed-car",
        route: "/services",
        permission: "services",
      },
      {
        title: "Check-in",
        icon: "mdi-car-key",
        route: "/checkin",
        permission: "checkin",
      },
      {
        title: "Vehículos",
        icon: "mdi-car-multiple",
        route: "/vehicles",
        permission: "vehicles",
      },
      {
        title: "Inventario",
        icon: "mdi-package",
        route: "/resources",
        permission: "resources",
      },
      {
        title: "Clientes",
        icon: "mdi-account-multiple",
        route: "/clients",
        permission: "clients",
      },
      /*{
        title: "Test",
        icon: "mdi-account-multiple",
        route: "/Test",
        permission: "",
      },*/
      //{ title: 'Perfil', icon: 'mdi-account', route: '/profile' },
      //{ title: 'Configuración', icon: 'mdi-cog', route: '/settings' },
    ],
  }),
  methods: {
    checkPermission(permission) {
      if (!permission) return true;
      return this.permissions[permission].status;
    },
    navigate(route) {
      if (this.$route.path == route) {
        return;
      }
      this.$router.push(route).catch(() => {});
    },
    goTo(path) {
      if (this.$route.path == path) {
        return;
      }
      this.$router.push(path).catch(() => {});
    },
    async logout() {
      //Loading para carga al realizar el deslogueo
      //this.changeValueLoading(true);
      this.$store
        .dispatch("auth/logout")
        .then((res) => {
          if (res.status == 200) {
            // Limpiar el token almacenado en localStorage
            localStorage.removeItem("token");
            this.$store.commit("auth/setAuthentication", false);
            // Redirigir al usuario a la página de inicio de sesión
            this.$router.push("/login").catch(() => {});
          } else if (res.status == 403) {
          }
          //this.changeValueLoading(false);
        })
        .catch((err) => {
          this.msg = err.response.data.msg;
          //this.changeValueLoading(false);
        });
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    user() {
      return this.$store.getters["auth/getUser"];
    },
    permissions() {
      return this.$store.getters["auth/permissions"];
    },
  },
};
</script>
  